import { compose, branch, renderComponent } from 'recompose';
import { isAdminSite } from '~/utils';

import AdminHeader from './AdminHeader';
import LearnerHeader from './LearnerHeader';

export { default as useHeaderOffset } from './useHeaderOffset';

export default compose(branch(() => !!isAdminSite(), renderComponent(AdminHeader)))(LearnerHeader);
